module.exports = __webpack_public_path__ + "static/media/Delay Modeler High Gain VR.ad6cffd.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/modeler/Delay Modeler High Gain VR.mp3
// module id = PjBJ
// module chunks = 12